import { styled } from '@mui/material';
import { FinishedSignupPage, SignupPage, SignupProfilePage } from 'components/SignUp';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/SignUp/PageProvider';
import { useContext } from 'react';
import { Box, Container, Copyright, Logo, Stack } from 'shell/components';

const Mobile = () => {
    const { device } = useViewport();
    const {
        loading,
        currentStep,
        form,
        errors,
        handleSignUp,
        handleCreateAccount,
        handleConfirmationCode,
        handleChange,
        handleResendCode,
        signInWithGoogle,
        PAGES,
        passwordRequirements,
        setCurrentStep,
    } = useContext(PageContext);

    return (
        <Container device={device} sx={{ height: '100%' }}>
            <CustomBox>
                <CustomStack alignItems={'center'} spacing={8}>
                    <Stack alignItems={'center'} spacing={2}>
                        <Logo device={'desktop'} />
                    </Stack>
                    {currentStep === PAGES.CREATE_ACCOUNT && (
                        <SignupPage
                            device={device}
                            loading={loading}
                            errors={errors}
                            form={form}
                            handleChange={handleChange}
                            handleSignUp={handleSignUp}
                            signInWithGoogle={signInWithGoogle}
                        />
                    )}
                    {currentStep === PAGES.PROFILE && (
                        <SignupProfilePage
                            device={device}
                            loading={loading}
                            form={form}
                            errors={errors}
                            passwordRequirements={passwordRequirements}
                            handleChange={handleChange}
                            handleBack={() => setCurrentStep(PAGES.CREATE_ACCOUNT)}
                            handleCreateAccount={handleCreateAccount}
                        />
                    )}
                    {currentStep === PAGES.VERIFY_EMAIL && (
                        <FinishedSignupPage
                            device={device}
                            email={form.email}
                            code={form.code}
                            error={errors.code}
                            loading={loading}
                            handleChange={handleChange}
                            handleConfirmationCode={handleConfirmationCode}
                            handleResendCode={handleResendCode}
                        />
                    )}
                </CustomStack>
                <Copyright />
            </CustomBox>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        height: '100%',
        paddingTop: theme.spacing(18),
    };
});

const CustomBox = styled(Box)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateRows: '1fr max-content',
        justifyItems: 'center',
        gridGap: theme.spacing(4),
        height: '100%',
        paddingBottom: theme.spacing(5),
    };
});

export default Mobile;
